export { TakePictureButton, type TakePictureButtonProps } from './TakePictureButton';
export { type MonkTakePictureButtonProps } from './hooks';
